import React from "react";

class ResponsivePicture extends React.Component {
	constructor(props) {
		super(props);
		let ruta = props.route.split("/");
		let file = ruta.pop();
		if (ruta[ruta.length - 2] == "icon") {
			ruta[ruta.length - 2] = "processed";
		}
		ruta = ruta.join("/");
		file = file.split(".");

		const ext = file.pop();
		let filename = "";
		if (file.length > 0) {
			filename = file[0].replace("@2x", "");
		} else {
			console.log(props.route);
		}
		let base = `${ruta}/${filename}${
			this.props.type != "" ? `_${this.props.type}` : ""
		}_${this.props.device}`;

		this.state = {
			img_2x: base + "@2x." + ext,
			img: base + "." + ext,
			img_2x_webp: base + "@2x.webp",
			img_webp: base + ".webp"
		};
	}
	render() {
		const { img_2x, img, img_2x_webp, img_webp } = this.state;
		return (
			<picture>
				<source type="image/webp" srcSet={`${img_2x_webp} 2x, ${img_webp}`} />
				<source srcSet={`${img_2x} 2x, ${img}`} />
				<img
					className={this.props.imgClass}
					width={this.props.width}
					height={this.props.height}
					src={
						this.props.supports_webp
							? this.props.isRetina
								? img_2x_webp
								: img_webp
							: this.props.isRetina
							? img_2x
							: img
					}
				/>
			</picture>
		);
	}
}

ResponsivePicture.defaultProps = {
	imgClass: "",
	device: window && window.mobile ? "mobile" : "desktop",
	type: "",
	supports_webp: window && window.hasWebP,
	isRetina: window && window.isRetinadisplay,
	width: "",
	height: ""
};

export default ResponsivePicture;
